"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _QuestionOutline = _interopRequireDefault(require("../../icons-react/rebrand/QuestionOutline"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var HintButton = function HintButton(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$white = _ref.white,
    white = _ref$white === void 0 ? false : _ref$white;
  return /*#__PURE__*/_react["default"].createElement(StyledQuestionIcon, {
    className: className,
    $white: white
  });
};
var StyledQuestionIcon = (0, _styledComponents["default"])(_QuestionOutline["default"]).withConfig({
  displayName: "HintButton__StyledQuestionIcon",
  componentId: "sc-1anvmhv-0"
})(["display:inline-flex;cursor:pointer;height:14px;path{fill:var(--grey1);}", ""], function (_ref2) {
  var $white = _ref2.$white;
  return $white && (0, _styledComponents.css)(["path{fill:var(--white);}"]);
});
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(HintButton);